import { Component } from 'react'
import { ShippingParcel } from 'stylewhere/api'
import { List, RowProps, StatusChip } from 'stylewhere/components'
import { T, __ } from 'stylewhere/shared/i18n'
import { getDate, getAsnParcelStatusChip } from 'stylewhere/shared/utils'

interface Props extends RowProps {
  parcel: ShippingParcel
  onClick: () => void
  hideDate?: boolean
  isInbound?: boolean
}

export class ParcelListRow extends Component<Props> {
  render() {
    const { parcel, onClick, hideDate, isInbound } = this.props
    return (
      <List.Row mr={3} ml={3} pl={20} pr={20} pt={20} pb={20} onClick={onClick}>
        <List.Cell maxWidth={'18%'} p={5} label={__(T.misc.parcel)} value={parcel.code} />
        <List.Cell maxWidth={'18%'} p={5} label={__(T.misc.shipment)} value={parcel.asn?.code ?? '-'} />
        <List.Cell flex={0} width={240} p={5} label={__(T.misc.status)}>
          <StatusChip
            status={parcel.status || '?'}
            customStatusType={getAsnParcelStatusChip(parcel.status ?? '')}
            pv={1}
            fontSize={16}
          />
        </List.Cell>
        <List.Cell
          p={5}
          flex={1}
          label={isInbound ? __(T.misc.origin) : __(T.misc.destination)}
          value={isInbound ? parcel.asn?.originPlace?.description || '--' : parcel.asn?.destinationPlace?.description || '--'}
        />
        {!hideDate && (
          <List.Cell
            maxWidth={200}
            p={5}
            label={__(T.misc.creation_date)}
            value={parcel.creationDate ? getDate(new Date(parcel.creationDate).getTime()) : '--'}
          />
        )}
        <List.Cell
          flex={0}
          width={80}
          p={5}
          label={__(T.misc.read)}
          value={parcel.checklistId && parcel.checklistId !== null ? `${parcel.parcelEntryQuantity}/${parcel.checklistExpectedQuantity}` : `${parcel.parcelEntryQuantity}`}
        />
      </List.Row>
    )
  }
}
